<template>
    <VueSelect
        v-model="current"
        :disabled="disabled"
        :options="options"
        :reduce="row => row._id"
        label="name"
        @input="emitInput"
        @search="fetchOptions"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Nenhum ticket encontrado: <em>{{ search }}</em>.
            </template>
            <em v-else style="opacity: 0.5;">Digite para procurar...</em>
        </template>
    </VueSelect>
</template>

<script>
import {VueSelect} from 'vue-select'
import {H} from 'hennig-common'
import BaseComponent from './BaseComponent'

export default {
    name: 'TicketSelect',
    extends: BaseComponent,
    components: {VueSelect},
    props: ['filter', 'disabled'],
    data () {
        return {}
    },
    methods: {
        setValue (v) {
            this.fetchOptions(v, (loading) => {
                if (loading === false) {
                    this.current = v
                    this.emitInput(v)
                }
            })
        },
        fetchOptions (search, loading) {
            search = search || this.current
            if (!search) return

            loading(true)
            this.options = []
            H.rpc('Ticket', 'lookup', [search, this.filter], r => {
                if (r) {
                    this.options = r
                }

                loading(false)
            })
        }
    }
}
</script>

<style scoped>

</style>
